module.exports = __webpack_public_path__ + "static/media/11.ef286122.jpg";